import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { getGroupedByTypeUnitOfMeasurementsSelector } from "../../../selectors/selectors";

export const withUnitOfMeasurements = ComponentToWrap => {
  class UnitOfMeasurementsComponent extends PureComponent {
    static propTypes = {
      groupedByTypeUnitOfMeasurements: PropTypes.object,
      sessionPreferences: PropTypes.object,
      userMetadata: PropTypes.object
    };

    static defaultProps = {
      groupedByTypeUnitOfMeasurements: {},
      sessionPreferences: {},
      userMetadata: {}
    };

    get userUnits() {
      const { unitOfMeasurements: userMetadataUOM = {} } = this.props.userMetadata;
      const { unitOfMeasurements: sessionUOM = {} } = this.props.sessionPreferences;

      return {
        WEIGHT: sessionUOM.WEIGHT || userMetadataUOM.WEIGHT || this.getDefaultUnit("WEIGHT"),
        LENGTH: sessionUOM.LENGTH || userMetadataUOM.LENGTH || this.getDefaultUnit("LENGTH"),
        SURFACE: sessionUOM.SURFACE || userMetadataUOM.SURFACE || this.getDefaultUnit("SURFACE"),
        DIMENSION: sessionUOM.DIMENSION || userMetadataUOM.DIMENSION || this.getDefaultUnit("DIMENSION")
      };
    }

    getDefaultUnit = type => {
      const unitType = this.props.groupedByTypeUnitOfMeasurements[type];
      return unitType ? unitType.find(u => u.isDefault).uomId : null;
    };

    render() {
      return <ComponentToWrap {...this.props} unitOfMeasurementsPreferences={this.userUnits} />;
    }
  }

  const mapStateToProps = state => {
    return {
      sessionPreferences: state.app.sessionPreferences,
      groupedByTypeUnitOfMeasurements: getGroupedByTypeUnitOfMeasurementsSelector(state),
      userMetadata: state.app.userMetadata
    };
  };

  return connect(mapStateToProps)(UnitOfMeasurementsComponent);
};



// WEBPACK FOOTER //
// ./src/components/Common/Preferences/withUnitOfMeasurements.js